/** Progressive enhancement only: product selection and native forms work without this file. */
function initProduct(root) {
  if (root.dataset.ppReady) return;
  root.dataset.ppReady = "true";
  const component = root.querySelector("product-form-component");
  const form = component?.querySelector("form");
  const submit = form?.querySelector("button[type=\"submit\"]");
  const feedback = root.querySelector("[data-pp-feedback]");
  const sticky = root.querySelector("[data-pp-sticky]");
  const stickyButton = root.querySelector("[data-pp-sticky-add]");
  const stickyFeedback = root.querySelector("[data-pp-sticky-feedback]");
  const quantity = form?.querySelector("[name=\"quantity\"]");
  if (!form || !submit) return;
  let pending = false;
  let timeout;
  const say = (message, error = false) => {
    [feedback, stickyFeedback].forEach((node) => { if (node) { node.textContent = message; node.classList.toggle("is-error", error); } });
  };
  const finish = (message, error = false) => {
    if (!pending) return;
    pending = false;
    clearTimeout(timeout);
    component.removeAttribute("aria-busy");
    if (stickyButton) stickyButton.disabled = submit.disabled;
    say(message, error);
  };
  form.addEventListener("submit", (event) => {
    if (pending || submit.disabled || !form.checkValidity()) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }
    const validation = component.querySelector("quantity-selector-component")?.canAddToCart?.();
    if (validation && !validation.canAdd) {
      // Native Horizon displays its quantity-limit error without a cart event.
      // Do not enter a pending state for a request that will not be issued.
      say(`Puoi avere nel carrello al massimo ${validation.maxQuantity} pezzi di questo pennello.`, true);
      return;
    }
    pending = true;
    component.setAttribute("aria-busy", "true");
    if (stickyButton) stickyButton.disabled = true;
    say("Aggiunta al carrello in corso …");
    // Horizon owns submit, cart updates and its button state. Never issue a second request.
    timeout = setTimeout(() => finish("Controlla il carrello prima di aggiungere nuovamente l’articolo.", true), 25000);
  });
  component.addEventListener("cart:update", (event) => {
    if (event.target !== component) return;
    finish(event.detail?.data?.didError ? "" : "Nel carrello. Puoi continuare a esplorare.", Boolean(event.detail?.data?.didError));
  });
  component.addEventListener("cart:error", (event) => { if (event.target === component) finish("Non è stato possibile aggiungere l’articolo. Controlla il messaggio accanto alla scelta della misura.", true); });
  new MutationObserver(() => { if (stickyButton) stickyButton.disabled = pending || submit.disabled; }).observe(submit, { attributes: true, attributeFilter: ["disabled"] });
  const updateQuantityLabel = () => {
    const count = root.querySelector("[data-pp-sticky-quantity]");
    if (count && quantity.checkValidity()) count.textContent = `${quantity.value} × `;
  };
  quantity?.addEventListener("input", updateQuantityLabel);
  quantity?.addEventListener("change", updateQuantityLabel);
  component.addEventListener("quantity-selector:update", updateQuantityLabel);
  if (quantity) new MutationObserver(updateQuantityLabel).observe(quantity, { attributes: true, attributeFilter: ["data-cart-quantity"] });
  stickyButton?.addEventListener("click", () => {
    if (!form.reportValidity()) {
      component.scrollIntoView({ block: "center", behavior: matchMedia("(prefers-reduced-motion: reduce)").matches ? "instant" : "smooth" });
      return;
    }
    if (!pending && !submit.disabled) submit.click();
  });
  if (sticky && "IntersectionObserver" in window) {
    const observer = new IntersectionObserver(([entry]) => { sticky.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0; });
    observer.observe(component);
  }
}
const start = () => document.querySelectorAll("[data-panart-product]").forEach(initProduct);
if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start, { once: true });
else start();
document.addEventListener("shopify:section:load", start);
